var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lni_lni-media-server",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.3,34.2c0-3.4-2.8-6.3-6.3-6.3h-0.7V9c0-3.5-2.8-6.3-6.3-6.3H8.1C4.6,2.7,1.8,5.5,1.8,9v28.9c0,3.5,2.8,6.3,6.3,6.3 h11.3c0.1,0.2,0.2,0.3,0.3,0.5c-0.9,1.1-1.5,2.5-1.5,4v6.4c0,3.4,2.8,6.3,6.3,6.3H56c3.4,0,6.3-2.8,6.3-6.3v-6.4 c0-1.5-0.5-2.9-1.5-4c0.9-1.1,1.5-2.5,1.5-4V34.2z M57.8,34.2v6.4c0,1-0.8,1.8-1.8,1.8H24.5c-1,0-1.8-0.8-1.8-1.8v-6.4 c0-1,0.8-1.8,1.8-1.8H53c0,0,0,0,0.1,0s0,0,0.1,0H56C57,32.5,57.8,33.2,57.8,34.2z M50.8,9v7.2h-8.7l5.5-9H49C50,7.2,50.8,8,50.8,9 z M28.9,7.2l-5.5,9h-8.2l5.5-9H28.9z M34.1,7.2h8.2l-5.5,9h-8.2L34.1,7.2z M8.1,7.2h7.3l-5.5,9H6.3V9C6.3,8,7.1,7.2,8.1,7.2z  M6.3,37.9V20.7h44.5V28H24.5c-3.4,0-6.3,2.8-6.3,6.3v5.5H8.1C7.1,39.7,6.3,38.9,6.3,37.9z M57.8,55.1c0,1-0.8,1.8-1.8,1.8H24.5 c-1,0-1.8-0.8-1.8-1.8v-6.4c0-1,0.8-1.8,1.8-1.8H56c1,0,1.8,0.8,1.8,1.8V55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1,35c-1.2,0-2.3,1-2.3,2.3v0.1c0,1.2,1,2.3,2.3,2.3s2.3-1,2.3-2.3v-0.1C31.3,36,30.3,35,29.1,35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,35.1h-4.6c-1.2,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3H53c1.2,0,2.3-1,2.3-2.3S54.3,35.1,53,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1,49.4c-1.2,0-2.3,1-2.3,2.3v0.1c0,1.2,1,2.3,2.3,2.3s2.3-1,2.3-2.3v-0.1C31.3,50.4,30.3,49.4,29.1,49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,49.5h-4.6c-1.2,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3H53c1.2,0,2.3-1,2.3-2.3S54.3,49.5,53,49.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaServer);
export default __webpack_public_path__ + "static/media/media-server.3eade8e0139068ed66a57d9432d4199e.svg";
export { ForwardRef as ReactComponent };